/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddressSearchRequest {
	addressText?: string | null;
	building?: string | null;
	floor?: string | null;
	unitNo?: string | null;
	streetNo?: string | null;
	street?: string | null;
	suburb?: string | null;
	postCode?: string | null;
	state?: string | null;
	country?: string | null;
	entityIds?: string[] | null;
}

export interface CAOUserServiceContractsDtosAgencyAssociationDto {
	/** @format uuid */
	entityId?: string;
	name?: string | null;
	offices?: CAOUserServiceContractsDtosOfficeAssociationDto[] | null;
}

export interface CAOUserServiceContractsDtosCompanyAssociationDto {
	/** @format int32 */
	userProfileId?: number;

	/** @format uuid */
	entityId?: string;
	name?: string | null;
	agencies?: CAOUserServiceContractsDtosAgencyAssociationDto[] | null;
}

export interface CAOUserServiceContractsDtosOfficeAssociationDto {
	/** @format uuid */
	entityId?: string;
	name?: string | null;
}

export interface CommsServiceContractsDtosSendGridDeliveryEvent {
	email?: string | null;

	/** @format int32 */
	timestamp?: number;
	event?: string | null;
	reason?: string | null;
	'smtp-id'?: string | null;
	sg_event_id?: string | null;
	sg_message_id?: string | null;

	/** @format uuid */
	KolmeoNotificationId?: string;
}

export interface CreateInvoiceLineItemRequest {
	description?: string | null;

	/** @format double */
	amount?: number;

	/** @format double */
	gst?: number;
}

export interface CreateMailroomInvoiceRequestDto {
	invoice?: CreatePropertyInvoiceRequest;

	/** @format int32 */
	documentId?: number;

	/** @format int32 */
	metadataId?: number;

	/** @format uuid */
	propertyEntityId?: string;
}

export interface CreateMailroomInvoiceResponseDto {
	invoice?: PropertyServiceContractsDTOsInvoiceInvoiceDto;
	isSuccess?: boolean;
	message?: string | null;
}

export interface CreateMailroomWorkflowRequestDto {
	workflow?: CreateWorkflowRequest;

	/** @format int32 */
	documentId?: number;

	/** @format int32 */
	metadataId?: number;

	/** @format uuid */
	propertyEntityId?: string;
}

export interface CreateMailroomWorkflowResponseDto {
	workflow?: WorkflowServiceContractsDTOsWorkflowDto;
	isSuccess?: boolean;
	message?: string | null;
}

export interface CreatePropertyInvoiceRequest {
	/** @format int32 */
	invoiceCategoryCode: number;

	/** @format int32 */
	propertyId: number;

	/** @format int32 */
	supplierUserProfileId?: number | null;
	supplierInvoiceNumber?: string | null;

	/** @format int32 */
	workOrderId?: number | null;

	/** @format date-time */
	dueDate?: string;

	/** @format date-time */
	localDueDate?: string;

	/** @format date-time */
	doNotPayBeforeDate?: string | null;

	/** @format double */
	amount?: number;
	description?: string | null;

	/** @format double */
	totalInvoiceAmount?: number;

	/** @format double */
	gst?: number;

	/** @format int32 */
	uploadedInvoiceDocumentId?: number | null;
	statusDescription?: string | null;
	lineItems?: CreateInvoiceLineItemRequest[] | null;
	payableBy?: KolmeoApplicationConstantsInvoicePayableByEnum;

	/** @format uuid */
	payableByEntityId?: string;

	/** @format int32 */
	payableByPaymentAccountId?: number | null;
	payableTo?: KolmeoApplicationConstantsInvoicePayableToEnum;

	/** @format uuid */
	payableToEntityId?: string | null;

	/** @format int32 */
	payableToPaymentAccountId?: number | null;
	payableToBpayOutBillerCode?: string | null;
	payableToBpayOutCustomerReferenceNumber?: string | null;
	isPayableByRent?: boolean;

	/** @format int32 */
	payableByOccupancyTenantId?: number | null;

	/** @format int32 */
	payableToOccupancyTenantId?: number | null;
	invoiceAltId?: string | null;
}

export interface CreateWorkflowRequest {
	/** @format uuid */
	workflowGuid: string;

	/** @format int32 */
	workflowTypeId: number;

	/** @format int32 */
	propertyId: number;
	subject: string;
	description?: string | null;

	/** @format int32 */
	assignedToUserId?: number;

	/** @format uuid */
	assignedToProfileId?: string;

	/** @format date-time */
	notificationResumeDate?: string | null;
	workflowItems?: WorkflowItemDto[] | null;
	isUrgent?: boolean;

	/** @format date-time */
	targetDate?: string | null;
}

export interface DocGenServiceContractsRequestsGenerateLedgerTenancyRequest {
	/** @format uuid */
	occupancyEntityId?: string;

	/** @format date-time */
	fromDate?: string | null;

	/** @format date-time */
	toDate?: string | null;
}

export interface DocGenServiceModelsDTOsDocGenGenerateDto {
	/** @format int32 */
	templateHeaderId?: number;

	/** @format int32 */
	occupancyId?: number | null;

	/** @format int32 */
	propertyId?: number | null;

	/** @format uuid */
	entityId?: string | null;

	/** @format int32 */
	entityTypeCode?: number | null;
}

export interface DocGenServiceModelsDTOsGenerateInvoiceRequest {
	/** @format uuid */
	invoiceGuid?: string;
}

export interface DocGenServiceModelsDTOsGenerateWorkOrderRequest {
	/** @format uuid */
	workOrderGuid?: string;
}

export interface GraphQLGatewayAPIServicesModelsDocGenGenerateInspectionEntryNotice {
	/** @format int32 */
	inspectionId?: number;
}

export interface GraphQLGatewayCoreModelsNotificationsStatusCallbackRequest {
	/** @format int32 */
	sendStatusCode?: number;
	externalRef?: string | null;
	errorMessage?: string | null;
}

/**
 * @format int32
 */
export type KolmeoApplicationConstantsInvoicePayableByEnum = 4003001 | 4003002 | 4003003 | 4003004 | 4003005;

/**
 * @format int32
 */
export type KolmeoApplicationConstantsInvoicePayableToEnum = 4004001 | 4004002 | 4004003 | 4004004 | 4004005 | 4004006 | 4004007;

export interface KolmeoCommonModelsAgency {
	/** @format uuid */
	agencyEntityId?: string;
	offices?: KolmeoCommonModelsOffice[] | null;
	isExplicitAssociation?: boolean;
}

export interface KolmeoCommonModelsCaoAssociation {
	/** @format uuid */
	companyEntityId?: string;
	agencies?: KolmeoCommonModelsAgency[] | null;
	restrictionLevel?: KolmeoCommonModelsCaoRestrictionLevel;
	isExplicitAssociation?: boolean;
}

/**
 * @format int32
 */
export type KolmeoCommonModelsCaoRestrictionLevel = 0 | 1 | 2 | 3;

export interface KolmeoCommonModelsOffice {
	/** @format uuid */
	officeEntityId?: string;
	isExplicitAssociation?: boolean;
}

/**
 * @format int32
 */
export type MailroomServiceContractsEnumsEvaluationStatus = 1 | 2 | 3 | 4;

export interface MetadataDto {
	/** @format int32 */
	metadataId?: number;

	/** @format int32 */
	documentId?: number;
	metadataFilename?: string | null;
	artefactFilename?: string | null;

	/** @format date-time */
	metadataCreatedAt?: string | null;

	/** @format date-time */
	documentCreatedAt?: string | null;
	recordType?: string | null;

	/** @format date-time */
	lockedAt?: string | null;

	/** @format int32 */
	lockedByUserId?: number | null;

	/** @format uuid */
	entityId?: string;
	evaluationStatus?: MailroomServiceContractsEnumsEvaluationStatus;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
	type?: string | null;
	title?: string | null;

	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
}

export interface MicrosoftExtensionsDiagnosticsHealthChecksHealthReport {
	entries?: Record<string, MicrosoftExtensionsDiagnosticsHealthChecksHealthReportEntry>;
	status?: MicrosoftExtensionsDiagnosticsHealthChecksHealthStatus;

	/** @format date-span */
	totalDuration?: string;
}

export interface MicrosoftExtensionsDiagnosticsHealthChecksHealthReportEntry {
	data?: Record<string, any>;
	description?: string | null;

	/** @format date-span */
	duration?: string;
	exception?: any;
	status?: MicrosoftExtensionsDiagnosticsHealthChecksHealthStatus;
	tags?: string[] | null;
}

/**
 * @format int32
 */
export type MicrosoftExtensionsDiagnosticsHealthChecksHealthStatus = 0 | 1 | 2;

export interface PagedResultMetadataDto {
	/** @format int32 */
	pageCount?: number;

	/** @format int32 */
	rowCount?: number;
	results?: MetadataDto[] | null;

	/** @format int32 */
	currentPage?: number;

	/** @format int32 */
	pageSize?: number;
}

export interface PagedResultPropertyAddressSearchResultDto {
	/** @format int32 */
	pageCount?: number;

	/** @format int32 */
	rowCount?: number;
	results?: PropertyAddressSearchResultDto[] | null;

	/** @format int32 */
	currentPage?: number;

	/** @format int32 */
	pageSize?: number;
}

export interface PagedUserProfileDto {
	/** @format int32 */
	pageCount?: number;

	/** @format int32 */
	rowCount?: number;
	results?: UserServiceContractsDtosUserProfileDto[] | null;

	/** @format int32 */
	currentPage?: number;

	/** @format int32 */
	pageSize?: number;
}

export interface PropertyServiceContractsDTOsInvoiceInvoiceActionDto {
	/** @format int32 */
	invoiceActionId?: number;

	/** @format int32 */
	invoiceId?: number;

	/** @format uuid */
	invoiceGuid?: string;

	/** @format int32 */
	actionCode?: number;

	/** @format double */
	amount?: number | null;
	actionDescription?: string | null;
	isActioned?: boolean;

	/** @format uuid */
	actionedByProfileId?: string | null;

	/** @format date-time */
	actionedDate?: string | null;

	/** @format uuid */
	transactionEntityId?: string | null;

	/** @format uuid */
	disbursementEntityId?: string | null;

	/** @format date-time */
	createdDate?: string;

	/** @format date-time */
	modifiedDate?: string;
	isDeleted?: boolean;
}

export interface PropertyServiceContractsDTOsInvoiceInvoiceDto {
	/** @format int32 */
	invoiceId?: number;

	/** @format uuid */
	invoiceGuid?: string;
	invoiceAltId?: string | null;

	/** @format int32 */
	recordStatusCode?: number;

	/** @format int32 */
	invoiceCategoryCode?: number | null;

	/** @format int32 */
	propertyId?: number;

	/** @format int32 */
	supplierUserProfileId?: number | null;
	supplierInvoiceNumber?: string | null;

	/** @format date-time */
	dueDate?: string;

	/** @format date-time */
	localDueDate?: string;

	/** @format date-time */
	doNotPayBeforeDate?: string | null;
	description?: string | null;

	/** @format double */
	amount?: number | null;

	/** @format double */
	gst?: number;

	/** @format double */
	totalInvoiceAmount?: number;

	/** @format double */
	balance?: number;

	/** @format int32 */
	uploadedInvoiceDocumentId?: number | null;

	/** @format uuid */
	createdByProfileId?: string;

	/** @format date-time */
	createdDate?: string;

	/** @format uuid */
	modifiedByProfileId?: string;

	/** @format date-time */
	modifiedDate?: string;
	isDeleted?: boolean;
	statusDescription?: string | null;

	/** @format int32 */
	invoiceTemplateId?: number | null;

	/** @format int32 */
	workOrderId?: number | null;
	lineItems?: PropertyServiceContractsDTOsInvoiceInvoiceLineItemDto[] | null;
	invoiceActions?: PropertyServiceContractsDTOsInvoiceInvoiceActionDto[] | null;
	isActionRequired?: boolean;
	payableBy?: KolmeoApplicationConstantsInvoicePayableByEnum;

	/** @format uuid */
	payableByEntityId?: string;

	/** @format int32 */
	payableByPaymentAccountId?: number | null;
	payableByBpayInBillerCode?: string | null;
	payableByBpayInCustomerReferenceNumber?: string | null;
	isPayableByRent?: boolean;
	payableTo?: KolmeoApplicationConstantsInvoicePayableToEnum;

	/** @format uuid */
	payableToEntityId?: string | null;

	/** @format int32 */
	payableToPaymentAccountId?: number | null;
	payableToBpayOutBillerCode?: string | null;
	payableToBpayOutCustomerReferenceNumber?: string | null;

	/** @format int32 */
	payableByOccupancyTenantId?: number | null;

	/** @format int32 */
	payableToOccupancyTenantId?: number | null;
}

export interface PropertyServiceContractsDTOsInvoiceInvoiceLineItemDto {
	/** @format uuid */
	invoiceLineItemGuid?: string;

	/** @format uuid */
	invoiceGuid?: string;
	description?: string | null;

	/** @format double */
	amount?: number;

	/** @format double */
	gst?: number;
}

export interface PropertyAddressSearchResultDto {
	/** @format uuid */
	entityId?: string;

	/** @format int32 */
	propertyId?: number;

	/** @format int32 */
	addressId?: number;
	buildingName?: string | null;
	unitNo?: string | null;
	floor?: string | null;
	streetNo?: string | null;
	streetName?: string | null;
	suburbName?: string | null;
	postCode?: string | null;
	stateName?: string | null;
	countryName?: string | null;
	propertyName?: string | null;

	/** @format uuid */
	propertyManagerUserProfileEntityId?: string;

	/** @format int32 */
	propertyManagerUserId?: number;

	/** @format uuid */
	associatedCompanyEntityId?: string;

	/** @format uuid */
	associatedAgencyEntityId?: string;

	/** @format uuid */
	associatedOfficeEntityId?: string;
	companyName?: string | null;
	agencyName?: string | null;
	officeName?: string | null;
	propertyOwners?: PropertyOwnerViewDto[] | null;
}

export interface PropertyOwnerViewDto {
	/** @format uuid */
	entityId?: string;
	firstName?: string | null;
	lastName?: string | null;
	titleCode?: string | null;
}

export interface SupplierSearchDto {
	profileName?: string | null;

	/** @format uuid */
	companyEntityId?: string;

	/** @format uuid */
	agencyEntityId?: string;

	/** @format uuid */
	officeEntityId?: string;
}

export interface UserServiceContractsDtosOwnerDetailDto {
	acceptsTermsAndConditions?: boolean | null;

	/** @format date-time */
	dateAcceptedTermsAndConditions?: string | null;
}

export interface UserServiceContractsDtosTenantDetailDto {
	acceptsTermsAndConditions?: boolean | null;

	/** @format date-time */
	dateAcceptedTermsAndConditions?: string | null;
}

export interface UserServiceContractsDtosUserDetailDto {
	titleCode?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	customSalutation?: string | null;
	businessName?: string | null;
	businessABN?: string | null;
	businessACN?: string | null;
	namePronunciation?: string | null;
	companyName?: string | null;
	companyAbn?: string | null;

	/** @format int32 */
	signOffAsUserId?: number | null;
	signOffName?: string | null;

	/** @format int32 */
	preferredContactDetailId?: number | null;

	/** @format int32 */
	positionTitleCode?: number | null;

	/** @format int32 */
	relationshipManagerId?: number | null;

	/** @format date-time */
	birthDate?: string | null;
	isGlobalVisible?: boolean | null;

	/** @format int32 */
	gstStatusCode?: number | null;
	gstExemptionNumber?: string | null;
	isReceiptRequired?: boolean | null;
	contactDetails?: string | null;
	alertText?: string | null;

	/** @format int32 */
	alternateContactUserId?: number | null;
	batchCodeOverride?: string | null;
	disclosureStatement?: string | null;
}

export interface UserServiceContractsDtosUserProfileDto {
	/** @format int32 */
	userProfileId?: number;

	/** @format uuid */
	entityId?: string;

	/** @format int32 */
	userId?: number;

	/** @format int32 */
	profileTypeId?: number;
	userProfileAltId?: string | null;
	importRef?: string | null;

	/** @format int32 */
	paymentProfileId?: number | null;
	userDetail?: UserServiceContractsDtosUserDetailDto;
	tenantDetail?: UserServiceContractsDtosTenantDetailDto;
	ownerDetail?: UserServiceContractsDtosOwnerDetailDto;
	caoAssociation?: KolmeoCommonModelsCaoAssociation;
	emailAddress?: string | null;
	isCompany?: boolean;

	/** @format uuid */
	createdByProfileId?: string;

	/** @format uuid */
	modifiedByProfileId?: string;

	/** @format date-time */
	createdDate?: string;

	/** @format date-time */
	modifiedDate?: string;
	isDeleted?: boolean;

	/** @format byte */
	timeStamp?: string | null;

	/** @format int32 */
	recordStatusCode?: number | null;
}

export interface UserServiceContractsRequestsB2CIdentityAssociationUserAssociationRequest {
	email?: string | null;

	/** @format uuid */
	b2cId?: string;
}

export interface UserProfile {
	/** @format int32 */
	userProfileId?: number;

	/** @format uuid */
	entityId?: string;

	/** @format int32 */
	userId?: number;

	/** @format int32 */
	profileTypeId?: number;

	/** @format int32 */
	recordStatusCode?: number | null;
	userDetail?: UserServiceContractsDtosUserDetailDto;
	emailAddress?: string | null;
	companyAssociation?: CAOUserServiceContractsDtosCompanyAssociationDto;
}

export interface WorkflowServiceContractsDTOsWorkflowDto {
	/** @format int32 */
	workflowId?: number;

	/** @format uuid */
	workflowGuid?: string;
	workflowAltId?: string | null;

	/** @format int32 */
	workflowTypeId?: number;

	/** @format int32 */
	propertyId?: number;
	subject?: string | null;
	description?: string | null;
	isUrgent?: boolean;

	/** @format date-time */
	targetDate?: string | null;

	/** @format int32 */
	assignedToUserId?: number;

	/** @format uuid */
	assignedToProfileId?: string;

	/** @format date-time */
	createdDate?: string;

	/** @format int32 */
	createdByUserId?: number;

	/** @format uuid */
	createdByProfileId?: string;

	/** @format date-time */
	modifiedDate?: string;

	/** @format int32 */
	modifiedByUserId?: number;

	/** @format uuid */
	modifiedByProfileId?: string;

	/** @format int32 */
	inspectionId?: number | null;

	/** @format int32 */
	workflowStatusTypeId?: number;

	/** @format date-time */
	notificationResumeDate?: string | null;
	workflowType?: WorkflowServiceContractsDTOsWorkflowTypeDto;
	workflowItems?: WorkflowItemDto[] | null;
	workflowRegister?: WorkflowServiceContractsDTOsWorkflowRegisterDto;
}

export interface WorkflowServiceContractsDTOsWorkflowRegisterDto {
	/** @format int32 */
	workflowRegisterId?: number;

	/** @format uuid */
	workflowGuid?: string;

	/** @format uuid */
	companyEntityId?: string;

	/** @format uuid */
	agencyEntityId?: string;

	/** @format uuid */
	officeEntityId?: string;
}

export interface WorkflowServiceContractsDTOsWorkflowTypeDto {
	/** @format int32 */
	workflowTypeId?: number;
	workflowTypeName?: string | null;
}

export interface WorkflowItemDto {
	/** @format uuid */
	workflowGuid?: string;

	/** @format int32 */
	workflowItemId?: number;

	/** @format uuid */
	workflowItemGuid?: string;

	/** @format int32 */
	workflowItemTypeId?: number;

	/** @format int32 */
	workflowStatusTypeId?: number;
	subject?: string | null;
	description?: string | null;

	/** @format date-time */
	actionDate?: string | null;

	/** @format int32 */
	identityId?: number | null;

	/** @format int32 */
	assignedToUserId?: number;

	/** @format uuid */
	assignedToProfileId?: string;

	/** @format date-time */
	createdDate?: string;

	/** @format int32 */
	createdByUserId?: number;

	/** @format uuid */
	createdByProfileId?: string;

	/** @format date-time */
	modifiedDate?: string;

	/** @format int32 */
	modifiedByUserId?: number;

	/** @format uuid */
	modifiedByProfileId?: string;
}

export interface DocgenGenerateagencytransactionsCreateParams {
	/** @format uuid */
	agencyEntityId?: string;
}

export interface DocgenGenerateoccupancytransactionsCreateParams {
	/** @format uuid */
	occupancyEntityId?: string;

	/** @format int32 */
	propertyId?: number;
}

export interface DocgenGenerateownershiptransactionsCreateParams {
	/** @format uuid */
	ownershipEntityId?: string;

	/** @format int32 */
	propertyId?: number;
}

export interface DocumentsTempCreateParams {
	/** @format int32 */
	id?: number;
}

export interface DocumentsDetailParams {
	size?: string;

	/** @format int32 */
	id: number;
}

export interface DocumentsPropertyimagesDetailParams {
	size?: string;

	/** @format int32 */
	id: number;
}

export interface DocumentsImageDetailParams {
	size?: string;

	/** @format int32 */
	id: number;
}

export interface DocumentsDisplayimageDetailParams {
	size?: string;

	/** @format int32 */
	id: number;
}

export interface GetPagedMailParams {
	/** @format int32 */
	currentPage?: number;

	/** @format int32 */
	pageSize?: number;
}

export interface GetDocumentByIdParams {
	size?: string;

	/** @format int32 */
	id: number;
}

export interface PropertySearchParams {
	/** @format int32 */
	currentPage?: number;

	/** @format int32 */
	pageSize?: number;
}

export interface SupplierSearchParams {
	/** @format int32 */
	currentPage?: number;

	/** @format int32 */
	pageSize?: number;
}

export namespace api {
	/**
 * No description
 * @tags B2CIdentityAssociation
 * @name B2CidentityassociationAssociateUserCreate
 * @summary Used by AzureAD B2C registration process to associated created AzureAD B2C user
with existing Kolmeo user by email.
 * @request POST:/api/b2cidentityassociation/associate-user
 * @response `200` `void` Success
*/
	export namespace B2CidentityassociationAssociateUserCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = UserServiceContractsRequestsB2CIdentityAssociationUserAssociationRequest;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenDocgengeneratetemplatedocxCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/docgengeneratetemplatedocx
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenDocgengeneratetemplatedocxCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = DocGenServiceModelsDTOsDocGenGenerateDto;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenDocgengeneratetemplatepdfCreate
	 * @summary Not used?
	 * @request POST:/api/docgen/docgengeneratetemplatepdf
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenDocgengeneratetemplatepdfCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = DocGenServiceModelsDTOsDocGenGenerateDto;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenGenerateagencytransactionsCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/generateagencytransactions
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenGenerateagencytransactionsCreate {
		export type RequestParams = {};
		export type RequestQuery = { agencyEntityId?: string };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenGenerateoccupancytransactionsCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/generateoccupancytransactions
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenGenerateoccupancytransactionsCreate {
		export type RequestParams = {};
		export type RequestQuery = { occupancyEntityId?: string; propertyId?: number };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenGenerateownershiptransactionsCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/generateownershiptransactions
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenGenerateownershiptransactionsCreate {
		export type RequestParams = {};
		export type RequestQuery = { ownershipEntityId?: string; propertyId?: number };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenGenerateworkorderCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/generateworkorder
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenGenerateworkorderCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = DocGenServiceModelsDTOsGenerateWorkOrderRequest;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenGeneratetenancyledgerCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/generatetenancyledger
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenGeneratetenancyledgerCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = DocGenServiceContractsRequestsGenerateLedgerTenancyRequest;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenGeneratestoreinvoiceCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/generatestoreinvoice
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenGeneratestoreinvoiceCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = DocGenServiceModelsDTOsGenerateInvoiceRequest;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenGenerateinspectionentrynoticeCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/generateinspectionentrynotice
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenGenerateinspectionentrynoticeCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = GraphQLGatewayAPIServicesModelsDocGenGenerateInspectionEntryNotice;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags DocGen
	 * @name DocgenDocgenuploadCreate
	 * @summary Used by admin portal
	 * @request POST:/api/docgen/docgenupload
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocgenDocgenuploadCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = {
			templateName?: string;
			templateDescription?: string;
			category?: string;
			subCategory?: string;
			isOverridable?: boolean;
			stateCode?: string;
			agencyEntityId?: string;
			officeEntityId?: string;
			template?: File;
		};
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsCreate
	 * @request POST:/api/documents
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocumentsCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = {
			categoryCode?: number;
			name?: string;
			sequenceNumber?: number;
			fileTypeCode?: number;
			isDefault?: boolean;
			isMarketing?: boolean;
			recordStatusCode?: number;
			file?: File;
			entityId?: string;
			entityTypeCode?: number;
			referenceProvider?: string;
			referenceTypeCode?: number;
			reference?: string;
			expiryDate?: string;
			referenceHolder?: string;
		};
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsTempCreate
	 * @request POST:/api/documents/temp
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocumentsTempCreate {
		export type RequestParams = {};
		export type RequestQuery = { id?: number };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsTempDetail
	 * @request GET:/api/documents/temp/{id}
	 * @response `200` `void` Success
	 */
	export namespace DocumentsTempDetail {
		export type RequestParams = { id: string };
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsDetail
	 * @request GET:/api/documents/{id}
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocumentsDetail {
		export type RequestParams = { id: number };
		export type RequestQuery = { size?: string };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsPropertyimagesDetail
	 * @request GET:/api/documents/propertyimages/{id}
	 * @response `200` `void` Success
	 */
	export namespace DocumentsPropertyimagesDetail {
		export type RequestParams = { id: number };
		export type RequestQuery = { size?: string };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsImageDetail
	 * @request GET:/api/documents/image/{id}
	 * @response `200` `void` Success
	 */
	export namespace DocumentsImageDetail {
		export type RequestParams = { id: number };
		export type RequestQuery = { size?: string };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsDisplayimageDetail
	 * @request GET:/api/documents/displayimage/{id}
	 * @response `200` `void` Success
	 */
	export namespace DocumentsDisplayimageDetail {
		export type RequestParams = { id: number };
		export type RequestQuery = { size?: string };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Documents
	 * @name DocumentsEntityDetail
	 * @request GET:/api/documents/entity/{entityId}
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace DocumentsEntityDetail {
		export type RequestParams = { entityId: string };
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name GetPagedMail
	 * @request GET:/api/mailroom/mail
	 * @secure
	 * @response `200` `PagedResultMetadataDto` Success
	 * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
	 * @response `401` `void` Unauthorized
	 */
	export namespace GetPagedMail {
		export type RequestParams = {};
		export type RequestQuery = { currentPage?: number; pageSize?: number };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = PagedResultMetadataDto;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name GetMailByEntityId
	 * @request GET:/api/mailroom/mail/{entityId}
	 * @secure
	 * @response `200` `MetadataDto` Success
	 * @response `204` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace GetMailByEntityId {
		export type RequestParams = { entityId: string };
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = MetadataDto;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name GetNextMailAsync
	 * @request GET:/api/mailroom/mail/next
	 * @secure
	 * @response `200` `MetadataDto` Success
	 * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
	 * @response `401` `void` Unauthorized
	 */
	export namespace GetNextMailAsync {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = MetadataDto;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name GetDocumentById
	 * @request GET:/api/mailroom/document/{id}
	 * @secure
	 * @response `200` `File` Success
	 * @response `204` `void` Success
	 * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
	 * @response `401` `void` Unauthorized
	 */
	export namespace GetDocumentById {
		export type RequestParams = { id: number };
		export type RequestQuery = { size?: string };
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = File;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name PropertySearch
	 * @request POST:/api/mailroom/property/search
	 * @secure
	 * @response `200` `PagedResultPropertyAddressSearchResultDto` Success
	 * @response `204` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace PropertySearch {
		export type RequestParams = {};
		export type RequestQuery = { currentPage?: number; pageSize?: number };
		export type RequestBody = AddressSearchRequest;
		export type RequestHeaders = {};
		export type ResponseBody = PagedResultPropertyAddressSearchResultDto;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name SupplierSearch
	 * @request POST:/api/mailroom/supplier/search
	 * @secure
	 * @response `200` `PagedUserProfileDto` Success
	 * @response `204` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace SupplierSearch {
		export type RequestParams = {};
		export type RequestQuery = { currentPage?: number; pageSize?: number };
		export type RequestBody = SupplierSearchDto;
		export type RequestHeaders = {};
		export type ResponseBody = PagedUserProfileDto;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name CreateWorkflow
	 * @request POST:/api/mailroom/workflow/create
	 * @secure
	 * @response `200` `CreateMailroomWorkflowResponseDto` Success
	 * @response `204` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace CreateWorkflow {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = CreateMailroomWorkflowRequestDto;
		export type RequestHeaders = {};
		export type ResponseBody = CreateMailroomWorkflowResponseDto;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name CreateInvoice
	 * @request POST:/api/mailroom/invoice/create
	 * @secure
	 * @response `200` `CreateMailroomInvoiceResponseDto` Success
	 * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
	 * @response `401` `void` Unauthorized
	 */
	export namespace CreateInvoice {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = CreateMailroomInvoiceRequestDto;
		export type RequestHeaders = {};
		export type ResponseBody = CreateMailroomInvoiceResponseDto;
	}
	/**
	 * No description
	 * @tags Mailroom
	 * @name MailroomUserProfilesList
	 * @request GET:/api/mailroom/user/profiles
	 * @secure
	 * @response `200` `(UserProfile)[]` Success
	 * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
	 * @response `401` `void` Unauthorized
	 */
	export namespace MailroomUserProfilesList {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = UserProfile[];
	}
	/**
	 * No description
	 * @tags Notifications
	 * @name NotificationsCallbacksCreate
	 * @request POST:/api/notifications/callbacks/{notificationGuid}
	 * @response `200` `void` Success
	 */
	export namespace NotificationsCallbacksCreate {
		export type RequestParams = { notificationGuid: string };
		export type RequestQuery = {};
		export type RequestBody = GraphQLGatewayCoreModelsNotificationsStatusCallbackRequest;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Notifications
	 * @name NotificationsCallbacksTwilioSmsCreate
	 * @request POST:/api/notifications/callbacks/{notificationGuid}/twilio-sms
	 * @response `200` `void` Success
	 */
	export namespace NotificationsCallbacksTwilioSmsCreate {
		export type RequestParams = { notificationGuid: string };
		export type RequestQuery = {};
		export type RequestBody = { smsSid?: string; messageSid?: string; smsStatus?: string; messageStatus?: string };
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Notifications
	 * @name NotificationsCallbacksSendgridWebhookCreate
	 * @request POST:/api/notifications/callbacks/sendgrid-webhook
	 * @response `200` `void` Success
	 */
	export namespace NotificationsCallbacksSendgridWebhookCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = CommsServiceContractsDtosSendGridDeliveryEvent[];
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksItemsCreate
	 * @request POST:/api/payment/callbacks/items
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksItemsCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksUsersCreate
	 * @request POST:/api/payment/callbacks/users
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksUsersCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksCompaniesCreate
	 * @request POST:/api/payment/callbacks/companies
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksCompaniesCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksAddressesCreate
	 * @request POST:/api/payment/callbacks/addresses
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksAddressesCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksAccountsCreate
	 * @request POST:/api/payment/callbacks/accounts
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksAccountsCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksDisbursementsCreate
	 * @request POST:/api/payment/callbacks/disbursements
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksDisbursementsCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksTransactionsCreate
	 * @request POST:/api/payment/callbacks/transactions
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksTransactionsCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags Payment
	 * @name PaymentCallbacksBatchTransactionsCreate
	 * @request POST:/api/payment/callbacks/batch_transactions
	 * @response `200` `void` Success
	 */
	export namespace PaymentCallbacksBatchTransactionsCreate {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = string;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags PowerBI
	 * @name PowerbiReportsRolesDetail
	 * @request GET:/api/powerbi/reports/{reportId}/roles/{role}
	 * @secure
	 * @response `200` `void` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace PowerbiReportsRolesDetail {
		export type RequestParams = { reportId: string; role: string };
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = { 'x-version': string };
		export type ResponseBody = void;
	}
	/**
	 * No description
	 * @tags UserProfiles
	 * @name UserprofilesList
	 * @summary Used by the admin portal and other front ends to get the list of all user profiles for the authenticated user (across all companies).
	 * @request GET:/api/userprofiles
	 * @secure
	 * @response `200` `(UserProfile)[]` Success
	 * @response `401` `void` Unauthorized
	 */
	export namespace UserprofilesList {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = UserProfile[];
	}
}

export namespace health {
	/**
	 * No description
	 * @tags Health
	 * @name HealthList
	 * @summary Checks the health of the API and its dependencies.
	 * @request GET:/health
	 * @response `200` `MicrosoftExtensionsDiagnosticsHealthChecksHealthReport` The API is healthy
	 * @response `424` `MicrosoftExtensionsDiagnosticsHealthChecksHealthReport` The API is degraded (non critical failures)
	 * @response `503` `MicrosoftExtensionsDiagnosticsHealthChecksHealthReport` The API has critical dependency failures
	 */
	export namespace HealthList {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = MicrosoftExtensionsDiagnosticsHealthChecksHealthReport;
	}
	/**
	 * No description
	 * @tags Health
	 * @name ReadyList
	 * @summary Checks if the API is ready.
	 * @request GET:/health/ready
	 * @response `200` `string` The service is ready
	 */
	export namespace ReadyList {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = string;
	}
	/**
	 * No description
	 * @tags Health
	 * @name LiveList
	 * @summary Checks if the API is live.
	 * @request GET:/health/live
	 * @response `200` `string` The service is live
	 */
	export namespace LiveList {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = string;
	}
	/**
	 * No description
	 * @tags Health
	 * @name MetadataList
	 * @summary Returns metadata about the service.
	 * @request GET:/health/metadata
	 * @response `200` `void`
	 */
	export namespace MetadataList {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
}

export namespace ping {
	/**
	 * No description
	 * @tags Ping
	 * @name PingList
	 * @summary Used to check connectivity with the service.
	 * @request GET:/ping
	 * @response `200` `void` The API is running and available.
	 */
	export namespace PingList {
		export type RequestParams = {};
		export type RequestQuery = {};
		export type RequestBody = never;
		export type RequestHeaders = {};
		export type ResponseBody = void;
	}
}
